import React, {Component} from 'react';

export default class Error403Page extends Component {
	render() {
		return (
			<div className="pages-error-403">
				403 Forbidden
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/04-containers/_pages/Error/403/index.js